import * as Yup from 'yup';
import CryptoJS from 'crypto-js';
import { requestApi } from 'app/utils/RestApi';
import { AUTH, OTP } from 'app/utils/constants/endPoint';
import { useProgram } from 'app/hooks/useProgram';
import appConfig from 'app/config/appConfig';

const schemaWebview = Yup.object().shape({
  nama: Yup.string()
    .required('Nama is required')
    .max(60, 'Nama tidak boleh lebih dari 60 karakter.'),
  kode: Yup.string()
    .required('Kode is required')
    .max(8, 'Kode harus memiliki 8 karakter.'),
  office: Yup.string(),
  email: Yup.string()
    .email('Email is not valid')
    .max(234, 'Email tidak boleh lebih dari 234 karakter.'),
  hp: Yup.string()
});

const checkToken = (encryptString) => {
  try {
    var base64EncodedKeyFromJava = 'QUJDREVGR0hJSktMTU5PUA==';
    var keyForCryptoJS = CryptoJS.enc.Base64.parse(base64EncodedKeyFromJava);

    var decodeBase64 = CryptoJS.enc.Base64.parse(encryptString)

    var decryptedData = CryptoJS.AES.decrypt({
      ciphertext: decodeBase64
    },
      keyForCryptoJS, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
    );

    var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
    return decryptedText
  } catch (error) {
    return false
  }
}

export const setupParams = (parameter, setParams, storeParams = false, errorCallback) => {
  const token = parameter.replace('?t=', '');
  const checkTokenData = checkToken(token);
  let errorMsg = ''
  try {
    var dataAgent = JSON.parse(checkTokenData);
    const nama = dataAgent.name.trim();
    const kode = dataAgent.agentCode.trim();
    const email = dataAgent.email.trim();
    const office = dataAgent.office.trim();
    const tokenStorage = localStorage.getItem("token")

    const program = appConfig.program;

    if (!kode) {
      errorMsg = 'Agent Code kosong'
    } else if (!nama) {
      errorMsg = 'Nama kosong'
    } else if (!email) {
      errorMsg = 'Email Anda kosong/belum terdaftar, maka mohon menghubungi Bagian Keagenan untuk melengkapi data sebelum melakukan registrasi pada ' + program + ' ini'
    }

    if (errorMsg) {
      errorCallback(errorMsg)
    }
    if (!tokenStorage) {
      (async () => {
        const resToken = await requestApi(AUTH.GENERATE_TOKEN, {
          subfolder: '/' + kode
        })
        const { token } = resToken.data.data;
        localStorage.setItem("token", token)
      })()
    }
    var hp = dataAgent.phoneNumber;
    if (hp.slice(0, 2) === '08')
      hp = hp.replace(/^0/, '62')

    schemaWebview.validate({
      nama,
      kode,
      email,
      office,
      hp
    })
      .then(data => {
        if (storeParams)
          localStorage.setItem('params', parameter)

        setParams(data);
      })
      .catch(error => {
        if (!errorMsg) {
          errorMsg = 'Mohon periksa kembali URL yang anda masukan'
        }
        errorCallback(errorMsg)
      });
  } catch (error) {
    if (!errorMsg) {
      errorMsg = 'Mohon periksa kembali URL yang anda masukan'
    }
    errorCallback(errorMsg)
  }
}


const schemaWebviewTnc = Yup.object().shape({
  agentCode: Yup.string()
    .required('Agent Code is required')
});

export const setupTncParams = (parameter, setParams, storeParams = false, errorCallback) => {
  const queryParams = new URLSearchParams(parameter);
  const agentCode = queryParams.get('agentCode');
  localStorage.setItem('agentCode', agentCode)
  schemaWebviewTnc.validate({
    agentCode
  })
    .then(data => {
      if (storeParams)
        localStorage.setItem('tncParams', parameter)

      setParams(data);
    })
    .catch(error => {
      errorCallback()
    });
}


export const setupParamsReferrer = (parameter, setParams, storeParams = false, errorCallback) => {
  const agentCode = parameter.replace('?agentCode=', '');

  if (agentCode) {
    schemaWebviewTnc.validate({
      agentCode
    })
      .then(data => {
        if (storeParams)
          localStorage.setItem('paramsReferrer', parameter)

        setParams(data);
      })
      .catch(error => {
        errorCallback()
      });
  } else {
    errorCallback()
  }
}

export const generateOTP = async (username, name, actionType = "DEFAULT") => {
  return await requestApi(OTP.GENERATE_OTP_AGENT, {
    data: {
      username,
      name,
      actionType
    }
  }).then(({ data }) => {
    return data;
  }).catch(err => {
    return err
  })
}

export const setupOTP = {
  timerDurationMinutes: 3,
  maxRestartLimit: 3,
  restartDelayMinutes: 5
}


export const isMobile = () => {
  return window.innerWidth <= 800; // You can adjust this value based on your needs
};
